import * as React from "react";
const SvgStar = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" {...props}><path fill="#FF8D6A" d="m22 33.4-11.1 5.8L13 26.9l-9-8.8 12.4-1.8L22 5l5.6 11.3L40 18.1l-9 8.8 2.1 12.3z" /></svg>;
export default SvgStar;